import { useTranslation } from 'react-i18next';

import { cn } from '@/utils/cn';

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ#'.split('');

export const MembersLetterRail = ({
  value,
  onChange,
  className,
}: {
  value: string | null;
  onChange: (letter: string | null) => void;
  className?: string;
}) => {
  const { t } = useTranslation('people');

  return (
    <nav
      className={cn('flex flex-col gap-0.5', className)}
      aria-label={t('members.letterRail.label')}
    >
      {LETTERS.map((letter) => {
        const active = value === letter || (letter === '#' && value === '#');
        return (
          <button
            key={letter}
            type="button"
            className={cn(
              'min-h-6 min-w-6 rounded px-1 text-caption font-medium',
              active
                ? 'bg-brand text-on-brand'
                : 'text-fg-secondary hover:bg-surface-sunken hover:text-fg',
            )}
            aria-current={active ? 'true' : undefined}
            aria-label={
              letter === '#'
                ? t('members.letterRail.other')
                : t('members.letterRail.letter', { letter })
            }
            onClick={() => onChange(active ? null : letter)}
          >
            {letter}
          </button>
        );
      })}
    </nav>
  );
};
